<template>
    <u-tooltip-outlined-rounded-lg v-bind="$attrs">
        <template v-for="(_, scopedSlotName) in $scopedSlots" v-slot:[scopedSlotName]="slotData">
            <slot :name="scopedSlotName" v-bind="slotData" />
        </template>
    </u-tooltip-outlined-rounded-lg>
</template>

<script>
import UTooltipOutlinedRoundedLg from "@/components/publish/styles/tooltips/u-tooltip-outlined-rounded-lg.vue";

export default {
    props: {},
    components: {
        UTooltipOutlinedRoundedLg,
    },
    data: () => {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped></style>
